module.exports = __webpack_public_path__ + "img/board-illust.446bd750.svg";